import { withNamespaces } from 'react-i18next';
import { Col, Label } from 'reactstrap';
import { AvField } from 'availity-reactstrap-validation';

const ComposeFields = ({
    t,
    isReply = false,
}) => {
    return (
        <>
            <Col sm="12" className="mb-3">
                <Label for="to">
                    {t('To')}
                </Label>
                <AvField
                    id="to"
                    name="to"
                    type="text"
                    className="form-control"
                    placeholder={t('Separate addresses with commas')}
                    validate={{
                        required: {
                            value: true,
                            errorMessage: t('Please enter at least one recipient.'),
                        },
                    }}
                />
            </Col>

            <Col sm="12" className="mb-3">
                <Label for="cc">
                    {t('Cc')}
                </Label>
                <AvField
                    id="cc"
                    name="cc"
                    type="text"
                    className="form-control"
                    placeholder={t('Separate addresses with commas')}
                />
            </Col>

            <Col sm="12" className="mb-3">
                <Label for="subject">
                    {t('Subject')}
                </Label>
                <AvField
                    id="subject"
                    name="subject"
                    type="text"
                    className="form-control"
                />
            </Col>

            <Col sm="12" className="mb-3">
                <Label for="body">
                    {t('Message')}
                </Label>
                <AvField
                    id="body"
                    name="body"
                    type="textarea"
                    rows="10"
                    className="form-control mailbox-compose__body"
                    placeholder={isReply ? t('Write your reply') : ''}
                />
            </Col>
        </>
    );
};

export default withNamespaces()(ComposeFields);
